import Icon from "./Icon.vue";
import { pluginify } from "./../../util";
export default pluginify(Icon);
export { Icon };
